import React from "react"
import PropTypes from "prop-types"
import { semantic } from '@lexody/design-tokens'


class PricingChoice  extends React.Component {

  constructor(props) {
    super(props)

    this.containerStyle = this.containerStyle.bind(this)
    this.mainSectionStyle = this.mainSectionStyle.bind(this)
  }

  componentWillMount() {
    if(this.props.size === 'large') {
      this.setState({
        backgroundColor: semantic.amber.surface.default,
        height: 425,
        width: 300,
        position: 'inherit',
        buttonMargin: 20
      })
    } else if (this.props.size === "medium") {
      this.setState({
        backgroundColor: semantic.primary.text.label,
        height: 375,
        width: 250,
        position: 'relative',
        buttonMargin: -45
      })
    } else {
      this.setState({
        backgroundColor: semantic.primary.text.label,
        height: 350,
        width: 260,
        position: 'relative',
        buttonMargin: -45
      })
    }
  }

  containerStyle() {
    if(this.props.selected === true) {
      return({
        backgroundColor: 'rgba(255, 255, 255, .5)',
        borderRadius: 10,
        height: this.state.height+15,
        width: this.state.width+15,
        display: 'inline-block',
      })
    }

    return({
      display: 'inline-block',
    })
  }

  mainSectionStyle() {
      return({
        backgroundColor: this.state.backgroundColor,
        borderRadius: 10,
        height: this.state.height,
        marginLeft: this.props.selected === true ? 7 : 12,
        marginRight: this.props.selected === true ? 7 : 12,
        marginTop: this.props.selected === true ? 7 : 0,
        padding: 22,
        width: this.state.width,
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        boxShadow: 'rgba(1, 87, 155, .5) 0px 4px 3px',
        marginBottom: 50,
      })
  }

  render() {
    return(
      <div style={this.containerStyle()}>
        <div style={this.mainSectionStyle()} >
          {this.props.selected && <h3 style={{backgroundColor: semantic.premium.surface.default, borderRadius: 3, padding: 5, marginTop: -45, marginBottom: 10, color: semantic.greyscale.text.negative}}>You got this!</h3>}
          <div style={{
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            height: this.props.size === 'small' ? 325 : 350
          }}>
            {this.props.children}
          </div>
          <button className={this.props.buttonText != '' ? "button_primary" : "btn_transparent"} onClick={this.props.onClick} style={{marginTop: this.state.buttonMargin, position: 'relative'}}>{this.props.buttonText}</button>
        </div>
      </div>
    )
  }
}

export default PricingChoice
